<template>
  <div class="rsy-home-box">
    <div class="rsy-home-content">
      <div class="rsy-home-header" :class="navBarFixed ? 'fixednav' : ''">
        <div class="rsy-home-header-content">
          <div class="rsy-logo">
            <img src="../../assets/login_white.svg" alt />
          </div>
          <div class="rsy-header-right">
            <div class="rsy-nav">
              <ul>
                <li v-for="(item, index) in navList" :key="index">
                  <a
                    href="javascript:void(0)"
                    class="rsy-parsen"
                    :class="
                      $route.path.startsWith(item.categoryListUrl)
                        ? 'active'
                        : ' '
                    "
                    @click="setcategoryList(item)"
                  >
                    {{ item.categoryTitle }}
                    <div
                      v-if="
                        item.categoryChildEntity.length > 0 &&
                          item.categoryChildEntity[0].categoryChildMinEntity
                            .length > 0
                      "
                      class="rsy-nav-children rsy-nav-children1"
                    >
                      <div
                        class="nav-item"
                        v-for="(child, index1) in item.categoryChildEntity"
                        :key="index1"
                      >
                        <h4>{{ child.categoryTitle }}</h4>
                        <a
                          href="javascript:void(0)"
                          v-for="(child1,
                          index2) in child.categoryChildMinEntity"
                          :class="
                            $route.path === child1.categoryListUrl
                              ? 'active1'
                              : ' '
                          "
                          :key="index2"
                          @click.stop="setcategoryListChild(child1)"
                          >{{ child1.categoryTitle }}</a
                        >
                      </div>
                    </div>
                    <div
                      v-if="
                        item.categoryChildEntity.length > 0 &&
                          item.categoryChildEntity[0].categoryChildMinEntity
                            .length === 0
                      "
                      class="rsy-nav-children"
                    >
                      <a
                        href="javascript:void(0)"
                        v-for="(child, index1) in item.categoryChildEntity"
                        :class="
                          $route.path === child.categoryListUrl
                            ? 'active1'
                            : ' '
                        "
                        :key="index1"
                        @click.stop="setcategoryListChild(child)"
                        >{{ child.categoryTitle }}</a
                      >
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="rsy-top-box">
        <div class="rsy-top-content">
          <img
            class="fadeInUp animated"
            src="../../assets/image/home11.png"
            alt
          />
          <div class="rsy-top-info">
            <img src="../../assets/image/home12.png" alt />
            <!-- <h3>医保大数据智慧赋能</h3>
            <p>
              HEALTH &nbsp;&nbsp;INSURANCE&nbsp;&nbsp; DATA&nbsp;
              &nbsp;ENABLING&nbsp; &nbsp;WISDOM
            </p>
            <span>互联网+数字医保</span>
            <i>|</i>
            <span>实现医保数据价值</span>-->
          </div>
        </div>
      </div>
      <div class="rsy-middle-box">
        <div class="rsy-middle-content">
          <h3 v-show="middle1Anmation" class="fadeInUp animated">
            为什么选择人社云
          </h3>
          <div
            v-show="middle1Anmation"
            class="rsy-middle-list fadeInUp animated"
            style="animation-delay: 0.2s"
          >
            <div class="rsy-middle-item">
              <img src="../../assets/image/home21.png" alt />
              <span>全民医保</span>
              <p>
                建立参保人、就医、用药全链路医保数据信息，提供参保人员画像和区域参保覆盖率，助力全民参保
              </p>
            </div>
            <div class="rsy-middle-item">
              <img src="../../assets/image/home22.png" alt />
              <span>安全医保</span>
              <p>
                开展医保智能监控工作、建立行为规则画像、完善医保基金风控体系，配合执法系统明确执法流程和制度，打造安全医保
              </p>
            </div>
            <div class="rsy-middle-item">
              <img src="../../assets/image/home23.png" alt />
              <span>科学医保</span>
              <p>
                利用医保数据分析，建立预算支付模型、查看基金整体态势、预测基金运行情况，科学规划基金使用
              </p>
            </div>
            <div class="rsy-middle-item">
              <img src="../../assets/image/home24.png" alt />
              <span>便捷医保</span>
              <p>
                智能报销系统提供全新医保报销模式，OCR智能识别技术。让服务多跑路，群众少跑路，助力至多跑一次改革
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="rsy-middle2-box">
        <div class="rsy-middle2-content">
          <h3>产品中心</h3>
          <div class="rsy-middle2-center">
            <img src="../../assets/image/homeleft1.png" alt />
            <img src="../../assets/image/homeleft2.png" alt />
            <img src="../../assets/image/homeleft3.png" alt />
            <img src="../../assets/image/homeleft4.png" alt />
            <img src="../../assets/image/homeright1.png" alt />
            <img src="../../assets/image/homeright2.png" alt />
            <img src="../../assets/image/homeright3.png" alt />
            <img src="../../assets/image/homeright4.png" alt />
          </div>
          <div class="rsy-middle2-left">
            <div
              class="rsy-middle2-left-content"
              :class="isAnmation ? 'anmationActiveLeft' : ' '"
            >
              <div class="rsy-middle2-item">
                <img src="../../assets/image/homeleft11.png" alt />
                <div class="rsy-middle2-info">
                  <p>医保执法</p>
                  <router-link to="/product/systemfive">查看详情></router-link>
                </div>
              </div>
              <div class="rsy-middle2-item">
                <img src="../../assets/image/homeleft21.png" alt />
                <div class="rsy-middle2-info">
                  <p>精准扶弱</p>
                  <router-link to="/product/systemsix">查看详情></router-link>
                </div>
              </div>
              <div class="rsy-middle2-item">
                <img src="../../assets/image/homeleft31.png" alt />
                <div class="rsy-middle2-info">
                  <p>智能分析</p>
                  <router-link to="/product/systemseven">查看详情></router-link>
                </div>
              </div>
              <div class="rsy-middle2-item">
                <img src="../../assets/image/homeleft41.png" alt />
                <div class="rsy-middle2-info">
                  <p>数据可视化</p>
                  <router-link to="/product/systemeight">查看详情></router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="rsy-middle2-right">
            <div
              class="rsy-middle2-right-content"
              :class="isAnmation ? 'anmationActiveRight' : ' '"
            >
              <div class="rsy-middle2-item">
                <div class="rsy-middle2-info">
                  <p>业务内控</p>
                  <router-link to="/product/systemone">查看详情></router-link>
                </div>
                <img src="../../assets/image/homeright11.png" v alt />
              </div>
              <div class="rsy-middle2-item">
                <div class="rsy-middle2-info">
                  <p>智能审核</p>
                  <router-link to="/product/systemtwo">查看详情></router-link>
                </div>
                <img src="../../assets/image/homeright21.png" alt />
              </div>
              <div class="rsy-middle2-item">
                <div class="rsy-middle2-info">
                  <p>运行分析</p>
                  <router-link to="/product/systemthree">查看详情></router-link>
                </div>
                <img src="../../assets/image/homeright31.png" alt />
              </div>
              <div class="rsy-middle2-item">
                <div class="rsy-middle2-info">
                  <p>画像分析</p>
                  <router-link to="/product/systemfour">查看详情></router-link>
                </div>
                <img src="../../assets/image/homeright41.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rsy-middle3-box">
        <div class="rsy-middle3-content">
          <h3>标杆客户青睐</h3>
          <div class="rsy-middle3-item">
            <img src="../../assets/image/home41.png" alt />
            <div class="rsy-middle3-indo mpTop1" v-show="middle3Anmation">
              <div class="fadeInUp animated" style="animation-delay: 1s">
                <h4>德清医保</h4>
                <p>
                  医保基金运行分析监测平台从不同对象，不同时间、不同区域等多业务维度监控医保基金运行情况并做数据分析，做到疫情可追踪、预算可监控、风险可把控。合理化释放医保数据价值。
                </p>
              </div>
            </div>
          </div>
          <div class="rsy-middle3-item">
            <div
              class="rsy-middle3-indo mpTop2 fadeInDown animated"
              style="animation-delay: 0.1s"
              v-show="middle3Anmation"
            >
              <h4>嘉兴医保</h4>
              <p>
                医保基金监管综合执法平台使办案流程更清晰，业务办理更快捷，数据统计分析更准确，执法管理更有效。使违法违规案件查办更高效，医保基金更安全。
              </p>
            </div>
            <img src="../../assets/image/home42.png" alt />
          </div>
          <div class="rsy-middle3-item">
            <img src="../../assets/image/home43.png" alt />
            <div class="rsy-middle3-indo mpTop1" v-show="middle3Anmation">
              <div class="fadeInUp animated" style="animation-delay: 1s">
                <h4>平湖医保</h4>
                <p>
                  医保智能审核系统依托深度的学习技术和海量的样本训练学习，提供智能识别技术。提高了票据识别速度和精准度，降低了业务办理难度，提高了业务人员工作效率，给参保人员带来了便捷体验。助力“最多跑一次”。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <demo-footer></demo-footer>
  </div>
</template>

<script>
import demoFooter from "../../components/mainContent/footer";
import $ from "jquery";

export default {
  name: "home",
  components: {
    demoFooter
  },

  data() {
    return {
      navList: [
        {
          categoryTitle: "首页",
          categoryListUrl: "/home",
          categoryChildEntity: []
        },
        {
          categoryTitle: "产品中心",
          categoryListUrl: "/product",
          categoryChildEntity: [
            {
              categoryTitle: "人社云",
              categoryChildMinEntity: [
                {
                  categoryTitle: "人社云精准扶弱管理系统",
                  categoryListUrl: "/product/systemsix"
                },
                {
                  categoryTitle: "人社云大数据智能分析平台",
                  categoryListUrl: "/product/systemseven"
                },
                {
                  categoryTitle: "人社云数据可视化分析平台",
                  categoryListUrl: "/product/systemeight"
                }
              ]
            },
            {
              categoryTitle: "医保云",
              categoryChildMinEntity: [
                {
                  categoryTitle: "业务经办服务智能内控系统",
                  categoryListUrl: "/product/systemone"
                },
                {
                  categoryTitle: "医保智能审核系统",
                  categoryListUrl: "/product/systemtwo"
                },
                {
                  categoryTitle: "医保基金运行分析监测系统",
                  categoryListUrl: "/product/systemthree"
                },
                {
                  categoryTitle: "医保基金画像分析系统",
                  categoryListUrl: "/product/systemfour"
                },
                {
                  categoryTitle: "医保基金监管综合执法平台",
                  categoryListUrl: "/product/systemfive"
                }
              ]
            }
          ]
        },
        {
          categoryTitle: "解决方案",
          categoryListUrl: "/plan",
          categoryChildEntity: [
            {
              categoryTitle: "人社云解决方案",
              categoryListUrl: "/plan/planone",
              categoryChildMinEntity: []
            },
            {
              categoryTitle: "医保云解决方案",
              categoryListUrl: "/plan/plantwo",
              categoryChildMinEntity: []
            }
            // { title: "商保云解决方案", path: "/plan/planthree" },
          ]
        },
        {
          categoryTitle: "关于我们",
          categoryListUrl: "/pcuser",
          categoryChildEntity: [
            // { title: "关于社宝", path: "/pcuser/aboutone" },
            // { title: "关于人社云", path: "/pcuser/abouttwo" },
            // { title: "公司地址", path: "/pcuser/aboutthree" },
          ]
        },
        {
          categoryTitle: "云生集团",
          categoryListUrl: "http://www.shebaochina.com/",
          categoryChildEntity: []
        }
      ],
      isTrue: false,
      middle1Anmation: false, //第二栏动画控制
      isAnmation: false, //  第三栏动画控制
      middle3Anmation: false, //第四栏动画控制
      navBarFixed: false
    };
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.slideScroll);
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.slideScroll);
    // this.getNavList();
  },
  methods: {
    slideScroll() {
      const jump = $(".rsy-middle2-box").offset().top;
      const scrollTop = $(document).scrollTop() + 600;

      const jump1 = $(".rsy-middle-box").offset().top;

      const jump2 = $(".rsy-middle3-box").offset().top;
      // console.log(jump1);
      // console.log(scrollTop);

      if (scrollTop >= jump) {
        this.isAnmation = true;
      }
      if (scrollTop >= jump1) {
        this.middle1Anmation = true;
      }
      if (scrollTop >= jump2) {
        this.middle3Anmation = true;
      }

      // if (scrollTop1 >= jump1) {
      //   this.navBarFixed = true;
      // } else {
      //   this.navBarFixed = false;
      // }
    },
    setcategoryList(data) {
      // console.log(data);
      if (data.categoryChildEntity.length === 0) {
        this.$store.dispatch("navId", data.id); //储存导航栏id
        this.$store.dispatch("categoryFlag", data.categoryFlag); //储存导航栏属性
        this.$store.dispatch("categoryId", data.categoryId); //储存导航栏父类型id
      } else {
        this.$store.dispatch("navId", data.categoryChildEntity[0].id); //储存导航栏id
        this.$store.dispatch(
          "categoryFlag",
          data.categoryChildEntity[0].categoryFlag
        ); //储存导航栏属性
        this.$store.dispatch(
          "categoryId",
          data.categoryChildEntity[0].categoryId
        ); //储存导航栏父类型id
      }
      if (data.categoryListUrl.indexOf("http://") > -1) {
        window.open(data.categoryListUrl, "_blank");
        // window.location.href = "http://www.shebaochina.com";
      } else {
        this.$router.push(data.categoryListUrl);
      }
    },
    setcategoryListChild(child) {
      this.$store.dispatch("navId", child.id); //储存导航栏父类型id
      this.$store.dispatch("categoryFlag", child.categoryFlag); //储存导航栏属性
      this.$store.dispatch("categoryId", child.categoryId); //储存导航栏父类型id
      this.$router.push(child.categoryListUrl);
    },
    //获取导航栏数据
    getNavList() {
      this.$fetch.api_user.navList().then(({ code, data, result }) => {
        if (code === 200) {
          this.$store.dispatch("navList", data.categoryModel); //
          this.$store.dispatch("navId", data.categoryModel[0].id); //储存导航栏id
          this.$store.dispatch(
            "categoryFlag",
            data.categoryModel[0].categoryFlag
          ); //储存导航栏属性
          this.$store.dispatch("categoryId", data.categoryModel[0].categoryId); //储存导航栏父类型id
          this.getcolumnInfo();
        }
      });
    },
    //获取列表数据
    getcolumnInfo() {
      this.$fetch.api_user
        .columnInfo({
          id: this.$store.state.id,
          categoryFlag: this.$store.state.categoryFlag,
          categoryId: this.$store.state.categoryId
        })
        .then(({ code, data, result }) => {
          if (code === 200) {
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/home.scss";
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue